module.exports = __webpack_public_path__ + "static/Bimpe-c9418235b9dfde423310e0dffbd37a1d.png";